import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { generateChatToUser } from '@/api/chat.api';
import { Button } from '@/components/UI/Button';

const ChatStart = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [error, setError] = useState('');

  useEffect(() => {
    const targetUserId = Number(userId);
    if (!Number.isInteger(targetUserId) || targetUserId <= 0) {
      setError(t('pbl.backlogEnhancements.chat.invalidRecipient'));
      return;
    }

    generateChatToUser({ user_id: targetUserId })
      .then(({ data }) => {
        if (!data.success || !data.data?.id) {
          throw new Error(data.message || t('pbl.backlogEnhancements.chat.startFailed'));
        }
        navigate('/chat?room=' + data.data.id, { replace: true });
      })
      .catch((reason) => {
        setError(reason?.response?.data?.message || reason?.message || t('pbl.backlogEnhancements.chat.startFailed'));
      });
  }, [navigate, t, userId]);

  return (
    <main style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <section style={{ maxWidth: 560, textAlign: 'center' }}>
        <h1>{error ? t('pbl.backlogEnhancements.chat.openFailed') : t('pbl.backlogEnhancements.chat.opening')}</h1>
        {error && <p>{error}</p>}
        {error && (
          <Button type="button" size="lg" variant="primary" onClick={() => navigate(-1)}>
            {t('pbl.backlogEnhancements.common.back')}
          </Button>
        )}
      </section>
    </main>
  );
};

export default ChatStart;
